/* import __COLOCATED_TEMPLATE__ from './change-conversation-priority.hbs'; */
/* RESPONSIBLE TEAM: team-help-desk-experience */
import templateOnlyComponent from '@ember/component/template-only';
import { type MacroAction } from 'embercom/objects/inbox/macro';

interface Signature {
  Args: { action: MacroAction };
}

const ChangeConversationPriority = templateOnlyComponent<Signature>();
export default ChangeConversationPriority;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::CommandK::UseMacro::Preview::ChangeConversationPriority': typeof ChangeConversationPriority;
    'inbox2/command-k/use-macro/preview/change-conversation-priority': typeof ChangeConversationPriority;
  }
}
